import DigiobcanApi, { type Issue } from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
  category?: string[];
  status?: Issue['status'][];
};

export const adminGetVotings = createQueryFn(
  QueryNameSpace.adminGetVotings,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params], string[]>) => {
    const [, params] = queryKey;

    const data = await DigiobcanApi.adminGetVotings({
      ...params,
      pagecursor: pageParam,
    });

    return data.votings;
  },
);
